import countries from 'i18n-iso-countries';

// ISO 3166-1 alpha-2 codes the UI supports.
// Keep this list stable: use it for validation, selects, and feature gating.
export const SUPPORTED_COUNTRY_ALPHA2 = Object.freeze([
  'AM','AZ','CY','EE','FR','GE','ID','IL','IN','JP','KZ','LT','LV','RU','UZ','VN'
]);

export const SUPPORTED_COUNTRY_ALPHA2_SET = new Set(SUPPORTED_COUNTRY_ALPHA2);

export function normalizeCountryAlpha2(value) {
  if (value == null) return null;
  const code = String(value).trim().toUpperCase();
  return code.length === 2 ? code : null;
}

export function isSupportedCountryAlpha2(value) {
  const code = normalizeCountryAlpha2(value);
  if (!code) return false;
  return SUPPORTED_COUNTRY_ALPHA2_SET.has(code);
}

/** Resolve company country (alpha-2 or numeric ISO) to alpha-2, or null. */
export function companyCountryAlpha2(company) {
  if (!company || typeof company !== 'object') return null;

  const raw =
    company.country_alpha2 ??
    company.countryAlpha2 ??
    company.country_code ??
    company.countryCode ??
    company.country ??
    null;
  if (raw == null || raw === '') return null;

  const asText = String(raw).trim().toUpperCase();
  const alpha2 = normalizeCountryAlpha2(asText);
  if (alpha2) return alpha2;

  const digits = asText.replace(/[^\d]/g, '');
  if (!digits) return null;
  try {
    return normalizeCountryAlpha2(countries.numericToAlpha2(digits.padStart(3, '0')));
  } catch {
    return null;
  }
}

